export class ComparedValueEntity {
  current!: number
  previous!: number
  diff!: number
}

export class UserBaseEntity {
  email!: string
  first_name!: string | null
  last_name!: string | null
  image_url!: string | null
}

// Media
export class UsersMediaItemEntity extends UserBaseEntity {
  songs_played!: ComparedValueEntity
  videos_viewed!: ComparedValueEntity
  livestream_participation!: ComparedValueEntity
}

export class UsersMediaPageEntity {
  total!: number
  items!: UsersMediaItemEntity[]
}

// Events
export class UsersEventsItemEntity extends UserBaseEntity {
  buy_now_clicks!: ComparedValueEntity
  presale_codes!: ComparedValueEntity
  meet_and_greet!: ComparedValueEntity
  vip!: ComparedValueEntity
  rsvp!: ComparedValueEntity
}

export class UsersEventsPageEntity {
  total!: number
  items!: UsersEventsItemEntity[]
}

// Forum
export class UsersForumItemEntity extends UserBaseEntity {
  views!: ComparedValueEntity
  posts!: ComparedValueEntity
  comments!: ComparedValueEntity
  upvotes!: ComparedValueEntity
}

export class UsersForumPageEntity {
  total!: number
  items!: UsersForumItemEntity[]
}

// Chat
export class UsersChatItemEntity extends UserBaseEntity {
  messages!: ComparedValueEntity
}

export class UsersChatPageEntity {
  total!: number
  items!: UsersChatItemEntity[]
}

// Totals
export class UserTotalsEntity extends UserBaseEntity {
  score!: number
}

export class UsersTotalsEntity {
  activity_type!: string
  users!: UserTotalsEntity[]
}
